import React, { type ReactNode } from 'react';
import { ContextualAnalyticsData, MODAL } from '@atlassian/jira-product-analytics-bridge';
import { useCommandPaletteAnalyticsAttributes } from '../../controllers/command-palette/index.tsx';

export const CommandPaletteWrapper = ({
	children,
}: {
	children?: ReactNode | null;
}): React.JSX.Element => {
	const [analyticsAttributes] = useCommandPaletteAnalyticsAttributes();
	return (
		<ContextualAnalyticsData
			sourceName="commandPalette"
			sourceType={MODAL}
			attributes={analyticsAttributes}
		>
			{children}
		</ContextualAnalyticsData>
	);
};
